<template>
	<div class="moonSampleSearchClass">
		<div class="moonContent" v-if="!inforFlag && !editInforFlag">
			<span class="moonClass" v-if="borrwingFlag">月球样品数据展示</span>
			<div class="searchDivClass">
				<div class="titleNameClass">
					<span class="lineClass"></span>
					<span class="sampleTypeClass">样品类型</span>
				</div>
				<div class="inforNameClass">
					<div class="spanDivClass" v-for="(item, index) in inforArr" :key="index">
						<span class="nameClass" v-if="item && item[0]">{{ item[0].level }}</span>
						<span
							:class="activeItem.includes(itemChild.name) ? 'typeClass1' : 'typeClass2'"
							v-for="(itemChild, indexC) in item"
							:key="indexC"
							@click="changeSampleType(itemChild, indexC)"
							>{{ itemChild.name }}</span
						>
					</div>
				</div>
				<div class="sampleEditClass">
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品编号</span>
						</div>

						<el-input v-model="sampleObj.code" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品原始重量</span>
						</div>
						<el-input v-model="sampleObj.currentWeight" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品特征</span>
						</div>
						<el-input v-model="sampleObj.content" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">使用状态</span>
						</div>
						<el-select v-model="sampleObj.statusList" multiple placeholder="请选择">
							<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<el-button class="btnClass" @click="searchSampleFunc()"> <i class="el-icon-check"></i>确定</el-button>
			</div>
			<div class="tableDataClass">
				<div style="text-align: left;">
					查询结果：共{{totalMoonSample}}条， 可申请：共{{totalCount.available_apply_count}}条， 审核中：共{{totalCount.under_review_count}}条， 已分发未取样：共{{totalCount.approved_not_token_count,}}条， 借用中：共{{totalCount.borrowing_count}}条， 返还检测中：共{{totalCount.return_test_count}}条
				</div>
				<el-table :data="moonSampleTableData" stripe :height="500" style="width: 100%">
					<el-table-column type="index" width="50" align="center"></el-table-column>
					<el-table-column prop="code" label="样品编号" width="150"> </el-table-column>
					<el-table-column label="样品类型" :width="220" align="left">
						<template slot-scope="scope">
							{{scope.row.sampleCategory1 != null ? scope.row.sampleCategory1 :''}}
							{{scope.row.sampleCategory2 != null ? '/'+ scope.row.sampleCategory2 :''}}
							{{scope.row.sampleCategory3 != null ? '/'+ scope.row.sampleCategory3 :''}} {{scope.row.sampleCategory4 != null ? '/'+ scope.row.sampleCategory4 :''}}
						</template>
					</el-table-column>

					<el-table-column prop="content" label="样品特征" width="200">
						<template slot-scope="scope">
							<span v-html="scope.row.content" style="font-size: unset;"></span>
						</template>
					 </el-table-column>
					<el-table-column prop="num" label="数量(个)" align="center">-- </el-table-column>
					<el-table-column prop="availableWeight" label="重量(mg)" align="center"> </el-table-column>
					<el-table-column prop="lidu" label="样品粒度(毫米)" :width="120" align="center"> --</el-table-column>
					<el-table-column label="样本照片">
						<template slot-scope="scope">
							<img v-if="scope.row.images && scope.row.images[0]" style="width: 44px; height: 44px" :src="scope.row.images[0].image.split(',')[0]" />
                    		<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column label="使用状态"
						><template slot-scope="scope">
							<span v-if="scope.row.status == 0">不可申请</span>
							<span v-else-if="scope.row.status == 1">可申请</span>
							<span v-else-if="scope.row.status == 2">内部借用</span>
							<span v-else-if="scope.row.status == 3">外部借用</span>
							<span v-else-if="scope.row.status == 5">反还监测中</span>
							<span v-else>审核中</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" :width="60">
						<template slot-scope="scope">
							<el-button @click="handleInforClick(scope.row)" type="text" size="small">详情</el-button>
							<!-- <el-button type="text" size="small" @click="editSample(scope.row)">编辑</el-button> -->
						</template>
					</el-table-column>
				</el-table>
				 <div class="block" style="background-color: #fff;height: 50px;display: flex;justify-content: end;align-items: center;">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="pageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalMoonSample">
					</el-pagination>
				</div>
			</div>
		</div>
		<sampleInfor v-if="inforFlag" ref="sampleInfoRef" @goBackFunc="goBackFunc"></sampleInfor>
		<editMoonSampleInfor v-if="editInforFlag" ref="editSampleRef" @goBackFunc="goBackFunc"></editMoonSampleInfor>
	</div>
</template>

<script>
import sampleInfor from '../sampleSearch/moonSampleInfor.vue'
import editMoonSampleInfor from '../sampleSearch/editMoonSampleInfor.vue'
export default {
	name: 'moonSampleIndex',
	props: {},
	components: {
		sampleInfor,
		editMoonSampleInfor
	},
	data() {
		return {
			options: [{
				value: '1',
				label: '可申请'
				}, {
				value: '2',
				label: '内部借用'
				}, {
				value: '3',
				label: '外部借用'
				}, {
				value: '4',
				label: '审核中'
				}, {
				value: '5',
				label: '反还监测中'
				}
				
			],
			totalCount:{},
			borrwingFlag: true,
			activeItem: [],
			activeLevel: [],
			activeItemObj: [],
			sampleObj: {
				code: '',
				content: '',
				statusList: [],
				currentWeight: ''
			},
			inforFlag: false,
			editInforFlag: false,
			moonSampleTableData: [],
			sampleNum: '',
			inforArr: [[{ level: '一级', itemChild: [] }]],
			currentPage: 1,
			pageSize: 10,
			totalMoonSample:0
		}
	},
	mounted() {
		this.getMoonSampleListFunc()
		this.initFunc()
		this.getMoonSampleStatusCount()
	},
	methods: {
		handleCurrentChange(val){
			this.currentPage = val
			this.initFunc()
		},
		handleSizeChange(val){
			this.pageSize = val
			this.initFunc()
		},
		changeSampleType(itemObj) {
			if (this.activeLevel.includes(itemObj.level) && this.activeItem.includes(itemObj.name)) {
				this.activeItem.forEach((element, index) => {
					if (element == itemObj.name) {
						this.activeItem.splice(index, 1)
						this.activeItemObj.splice(index, 1)
						this.activeLevel.splice(index, 1)
					}
				})
			} else {
				if (this.activeLevel.includes(itemObj.level)) {
					this.activeItemObj.forEach((element, indexObj) => {
						if (element.level == itemObj.level) {
							this.activeItem.splice(indexObj, 1)
							this.activeItemObj.splice(indexObj, 1)
							this.activeLevel.splice(indexObj, 1)
						}
					})
				}
				this.activeItem.push(itemObj.name)
				this.activeItemObj.push(itemObj)
				this.activeLevel.push(itemObj.level)
			}
			console.log(this.activeItemObj)
		},
		searchSampleFunc() {
			this.initFunc()
		},
		async getMoonSampleListFunc() {
			this.inforArr[0] = []
			this.inforArr[1] = []
			this.inforArr[2] = []
			this.inforArr[3] = []
             let res = await this.$http.get(this.$const.moonSample.getMoonSampleTypeList+`?pageNum=1&pageSize=100`);
            if (res && res.code==200) {
                const resultData = res.data
				resultData.forEach((element) => {
					if (element.level == '一级') {
						this.inforArr[0].push(element)
					} else if (element.level == '二级') {
						this.inforArr[1].push(element)
					} else if (element.level == '三级') {
						this.inforArr[2].push(element)
					} else {
						this.inforArr[3].push(element)
					}
				})
            }
		},
		async initFunc() {
			let sampleCategory1 = '',
				sampleCategory2 = '',
				sampleCategory3 = '',
				sampleCategory4 = ''

			if (this.activeItemObj && this.activeItemObj.length > 0) {
				this.activeItemObj.forEach((element) => {
					if (element.level == '一级') {
						sampleCategory1 += element.code + ','
					} else if (element.level == '二级') {
						sampleCategory2 += element.code + ','
					} else if (element.level == '三级') {
						sampleCategory3 += element.code + ','
					} else if (element.level == '四级') {
						sampleCategory4 += element.code + ','
					}
				})
				const reg = /,$/gi
				sampleCategory1 = sampleCategory1.replace(reg, '')
				sampleCategory2 = sampleCategory2.replace(reg, '')
				sampleCategory3 = sampleCategory3.replace(reg, '')
				sampleCategory4 = sampleCategory4.replace(reg, '')
			}
			const params = {
				pageNum:this.currentPage,
				pageSize:this.pageSize
			}
			if (sampleCategory1 !== '') params.sampleCategory1 = sampleCategory1
			if (sampleCategory2 !== '') params.sampleCategory2 = sampleCategory2
			if (sampleCategory3 !== '') params.sampleCategory3 = sampleCategory3
			if (sampleCategory4 !== '') params.sampleCategory4 = sampleCategory4
			if (this.sampleObj.code !== '') params.code = this.sampleObj.code
			if (this.sampleObj.content !== '') params.content = this.sampleObj.content
			if (this.sampleObj.status !== '') params.status = this.sampleObj.status
			if (this.sampleObj.currentWeight !== '') params.currentWeight = this.sampleObj.currentWeight

            let res = await this.$http.get(this.$const.moonSample.getMoonSampleList, params);
            if (res && res.code==200) {
                this.moonSampleTableData = res.rows
				this.totalMoonSample = res.total
            }
		},
		async getMoonSampleStatusCount(){
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleStatusCount);
			if (res && res.code==200) {
				this.totalCount = res.data
			}
		},
		handleInforClick(row) {
			console.log(row)
			this.inforFlag = true
			this.$nextTick(() => {
				this.$refs.sampleInfoRef.initDataFunc(row)
			})
		},
		editSample(row) {
			console.log(row)
			this.editInforFlag = true
			this.$nextTick(() => {
				this.$refs.editSampleRef.initDataFunc(row)
			})
		},
		goBackFunc(type) {
			if (type == 1) {
				this.inforFlag = false
			} else {
				this.editInforFlag = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.moonSampleSearchClass {
	width: 100%;
	// height: 1510px;
    text-align: center;
	background: #f0f5ff;
	margin-bottom: 20px;
	.moonContent {
		width: 1200px;
		text-align: center;
		display: inline-block;
		.moonClass {
			font-size: 28px;
			color: #000000;
			display: block;
			text-align: left;
			margin-top: 30px;
			margin-bottom: 30px;
		}
		.searchDivClass {
			// height: 246px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid rgba(21, 65, 140, 0.2);
			margin-bottom: 22px;
			padding: 10px;
			.titleNameClass {
				display: flex;
				justify-content: left;
				align-items: center;
				height: 30px;
				padding: 5px;
				.lineClass {
					width: 2px;
					height: 16px;
					background: #15418c;
				}
				.sampleTypeClass {
					height: 21px;
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 16px;
					color: #000000;
					line-height: 21px;
					text-align: left;
					font-style: normal;
					display: block;
					margin-left: 8px;
				}
			}

			.sampleEditClass {
				display: flex;
				justify-content: space-around;
				align-items: baseline;
				margin-top: 10px;
				.sampleNum {
					width: 280px;
					padding: 6px;
					.sampleNumTitleClass {
						display: flex;
						align-items: center;
						margin-bottom: 8px;
						.lineClass {
							width: 2px;
							height: 16px;
							background: #15418c;
						}
						.sampleNumClass {
							height: 21px;
							font-family: MicrosoftYaHeiUISemibold;
							font-size: 16px;
							color: #000000;
							line-height: 21px;
							text-align: left;
							font-style: normal;
							display: block;
							margin-left: 8px;
						}
					}
				}
			}
			.inforNameClass {
				display: flex;
				justify-content: left;
				align-items: baseline;
				flex-wrap: wrap;
				.spanDivClass {
					display: flex;
					justify-content: stretch;
					-webkit-box-align: baseline;
					align-items: center;
					padding: 8px;
					// width: 50%;
					height: 60px;
				}
				.nameClass {
					width: 50px;
					margin-right: 10px;
					height: 40px;
					font-family: MicrosoftYaHeiUI;
					font-size: 16px;
					color: #000000;
					line-height: 21px;
					text-align: left;
					font-style: normal;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.typeClass2:hover,
				.typeClass1 {
					// width: 116px;
					min-width: 96px;
					padding-left: 10px;
					padding-right: 10px;
					max-width: max-content;
					margin-right: 5px;
					height: 40px;
					background: #15418c;
					border-radius: 4px;
					color: #ffffff;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.typeClass2 {
					// width: 116px;
					height: 40px;
					min-width: 96px;
					padding-left: 10px;
					padding-right: 10px;
					max-width: max-content;
					margin-right: 5px;
					background: radial-gradient(396% 161% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
					border-radius: 4px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
			}
			.btnClass {
				background: #15418c;
				border-radius: 4px;

				font-family: MicrosoftYaHeiUI;
				font-size: 16px;
				color: #ffffff;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				line-height: 10px;
				text-align: left;
				font-style: normal;
				margin-top: 5px;
			}
		}
	}
}
</style>
<style >
.el-table th.el-table__cell.is-leaf {
	background-color: #15418c;
	color: #ffffff;
}
.el-table tr {
	background: #f0f5ff;
}
.el-table--enable-row-transition .el-table__body td.el-table__cell {
	color: #333333;
	font-size: 14px;
}
.sampleNum .el-input__inner {
	width: 280px;
	height: 36px;
	background: #fafafa;
	border-radius: 4px;
	border: 1px solid #cccccc;
}
</style>